<script setup>
    import { computed } from 'vue'
    import { MultiEdit } from '@/js/components/Common'
    import UserCreateDialog from '@/js/components/Benutzer/UserCreateDialog.vue'
    import { useUserStore } from '@/js/stores/user'

    const props = defineProps({
        lehrende: {
            type: Array,
            required: true
        },
        allowEdit: {
            type: Boolean,
            required: false,
            default: false
        },
        tooltip: {
            type: String,
            required: false,
            default: () => ''
        },
        language: {
            type: String,
            required: false,
            default: () => 'deutsch'
        }
    })

    const title = computed(() =>
        props.language === 'englisch' ? 'Lecturer | Lehrende' : 'Lehrende'
    )

    const userStore = useUserStore()
    const emit = defineEmits(['lehrendeSaved'])

    const saveLehrende = (lehrende) => {
        emit('lehrendeSaved', lehrende)
    }

    const userIdLabelMap = computed(() => {
        let lehrendeMap = []
        props.lehrende.forEach((id) => {
            const user = userStore.getUserById(id)
            lehrendeMap.push({
                id,
                label: `${user.titel} ${user.vorname} ${user.nachname}`
            })
        })
        return lehrendeMap
    })

    const autoCompleteUsers = computed(() => {
        return userStore.getUsersForAutocompletion
    })
</script>

<template>
    <multi-edit
        :title="title"
        edit-key="lehrende"
        :entries="userIdLabelMap"
        :handle-ids="true"
        :allow-edit="allowEdit"
        :auto-complete-data="autoCompleteUsers"
        :tool-tip="tooltip"
        @text-saved="saveLehrende"
    >
        <template #create-user-dialog>
            <user-create-dialog
                v-if="allowEdit"
                :with-role="false"
            >
                <template #activator="{ props }">
                    <v-btn
                        v-bind="props"
                        border
                        height="inherit"
                        class="border-primary border-opacity-100 text-grey"
                        color="primary-lighten-2"
                        tile
                        variant="flat"
                        icon="mdi-plus"
                    />
                </template>
            </user-create-dialog>
        </template>
    </multi-edit>
</template>

<script></script>

<style scoped></style>
